import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { shouldReloadForChunkLoadError, safeReloadOnce } from './app/core/errors/chunk-load-recover';
import { environment } from './environments/environment';

if (environment.disableConsole) {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
  console.error = noop;
}

/**
 * Handle unhandled promise rejections (e.g., chunk load errors in lazy-loaded modules)
 * This catches errors that might not be caught by Angular's ErrorHandler
 */
window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  const reason = event.reason;

  if (shouldReloadForChunkLoadError(reason)) {
    event.preventDefault();
    safeReloadOnce();
  }
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    if (shouldReloadForChunkLoadError(err)) {
      safeReloadOnce();
    }
  });
